import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { BillingInfo, Maybe, SubscriptionInput } from "types/generated";

import FormContent from "../Form";

/** @public (Knip ignored - used in the file and exported for testing) */
export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateSubscriptionInfo($input: SubscriptionInput!) {
    billingSubscriptionUpdateInfo(input: $input) {
      billingInfo {
        address
        city
        companyName
        country
        email
        fullName
        state
        zipCode
      }
    }
  }
`;

type BillingInvoiceFormWrapperProps = {
  billingInfo: Maybe<BillingInfo>;
};

const BillingInvoiceFormWrapper = ({ billingInfo }: BillingInvoiceFormWrapperProps) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const [updateSubscription, { loading }] = useMutation(UPDATE_SUBSCRIPTION);
  const [shouldRedirect, setShouldRedirect] = useState<boolean | null>(null);

  const sendData = (input: SubscriptionInput) => {
    updateSubscription({ variables: { input } })
      .then(() => {
        setShouldRedirect(true);
        reportSuccess({ message: "Invoice details were updated" });
      })
      .catch(onError);
  };

  if (shouldRedirect) {
    return <Navigate to="/settings/billing" />;
  }

  return <FormContent handleSubmit={sendData} loading={loading} {...billingInfo} />;
};

export default BillingInvoiceFormWrapper;
